import { Pinia, Store } from 'pinia-class-component';
import { GpsTrackerDto, GpsTrackerUiClient } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'GpsTrackerStore',
  name: 'GpsTrackerStore',
})
export default class GpsTrackerStore extends Pinia {
  private readonly gpsTrackerApi = initClient(GpsTrackerUiClient);

  //data
  private _loadingPromise: Promise<GpsTrackerDto[]> | null = null;
  private _gpsTrackers: GpsTrackerDto[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get gpsTrackers(): GpsTrackerDto[] {
    return this._gpsTrackers;
  }

  //actions
  clear(): void {
    this._gpsTrackers.splice(0);
  }

  setGpsTrackers(gpsTrackers: GpsTrackerDto[]): void {
    this._gpsTrackers.splice(0);
    this._gpsTrackers.push(...gpsTrackers);
  }

  addGpsTracker(gpsTracker: GpsTrackerDto): void {
    this._gpsTrackers.push(gpsTracker);
  }

  updateGpsTracker(gpsTracker: GpsTrackerDto): void {
    const index = this._gpsTrackers.findIndex(e => e.id == gpsTracker.id);
    if (index >= 0) {
      this._gpsTrackers.splice(index, 1, gpsTracker);
    } else {
      this._gpsTrackers.push(gpsTracker);
    }
  }

  forgetGpsTracker(gpsTracker: GpsTrackerDto): void {
    const index = this._gpsTrackers.findIndex(e => e.id == gpsTracker.id);
    if (index >= 0) {
      this._gpsTrackers.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.gpsTrackerApi.list();
      const gpsTrackers = await this._loadingPromise;
      this.setGpsTrackers(gpsTrackers);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._gpsTrackers.length > 0) {
      return;
    }
    return await this.reload();
  }
}